// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"afe40fe272fc0d10f454","655":"5983ec221a85e659ca90"}[chunkId] + ".js";
};